var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
// require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');


// import AOS from 'aos';
require('bootstrap-select');

// require('isotope-layout/dist/isotope.pkgd');
// require('imagesloaded');




require('owl.carousel');
// require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {


    $('.selectpicker').selectpicker({
        style:'btn-select',
    });

    $(".btn-filter").on('click', function() {
        $("#nav-filters").slideToggle('fast');
        $(".btn-filter span").toggleClass('open');
    });

    $(".btn-group button").on('click', function() {
        $(".btn-group button").removeClass('active');
        $(this).toggleClass('active');

    });

    $(window).on('resize load scroll', function() {

        //stops mobile menu shrinking on scroll when modal is open
        if ( $('#search-popup').css('display') == 'block'){
            $("#main-nav").addClass("no-scroll");

        }else if($('#login-popup').css('display') == 'block'){
            $("#main-nav").addClass("no-scroll");

        }else if($('#nav-mob').css('display') == 'block'){
            $("#main-nav").addClass("no-scroll");
           
        }else{
           $("#main-nav").removeClass("no-scroll");

        }

        //shrink nav
        var scroll = $(window).scrollTop();
        if (scroll > 64) {
            $('#main-nav').addClass('scroll-down')
        } else {
            $('#main-nav').removeClass('scroll-down')
        }

    });


    // $('.grid').isotope({
    //     // options
    //     percentPosition: true,
    //     itemSelector: '.grid-item',
    //     masonry: {
    //         // columnWidth: '.grid-sizer'
    //         columnWidth: 0,
    //         gutter: 40,
    //     }
    // });


    // $('.grid').each(function() {
    //     var $module = $(this);
    //     var update = function() {
    //         $module.isotope('layout'); // fix lazyload overlapping issues
    //     };
    //     // Note: Instead of waiting for all images until we initialize the widget
    //     // we use event capturing to update the widget's layout progressively.
    //     this.addEventListener('load', update, true);

    //     $module.isotope();
    // });

    // $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
    //     $('.grid').isotope('layout');
    // });


    $('#btn-menu').click(function() {
        $("#btn-login-popup, #btn-search-popup").removeClass("open");
        $(this).toggleClass('open');
        $("#nav-mob").fadeToggle('fast');
        $("#login-popup, #search-popup").fadeOut('fast');
    });

    $('#btn-search-popup').click(function() {
        $("#btn-menu, #btn-login-popup").removeClass("open");
        $(this).toggleClass('open');
        $("#search-popup").fadeToggle('fast');
        $("#login-popup, #nav-mob").fadeOut('fast');
    });

    $('#btn-login-popup').click(function() {
        $("#btn-menu, #btn-search-popup").removeClass("open");
        $(this).toggleClass('open');
        $("#login-popup").fadeToggle('fast');
        $("#nav-mob, #search-popup").fadeOut('fast');

    });

    $(".owl-sponsors").owlCarousel({
        autoWidth: true,
        dots: false,
        nav: false,
        autoplay:true,
        loop:true,
        margin: 12,
        smartSpeed:750,
        animateOut:true,
        responsive: {

            768: {
                margin: 24,
            }
        }
    });

    $('#membership').on('change', function (e) {
        if (e.target.checked) {
            $('#membership-details').removeClass('d-none');
            $('#membership-details input,select').attr('required', 1);
        } else {
            $('#membership-details').addClass('d-none');
            $('#membership-details input,select').removeAttr('required');
        }
    })

    function toggleAccountMessage(value) {
        $(`[name="account_type"]`).each(function (idx, el) {
            el.checked = el.value == value;
        });

        $(`.account-type-msg`).each(function (idx, el) {
            if ($(el).data('value') == value) {
                return $(el).removeClass('d-none');
            }

            $(el).addClass('d-none');
        });
    }

    $('[name="account_type"]').each(function (idx, el) {
        if (el.checked) {
            toggleAccountMessage(el.value);
        }
    })
    $('[name="account_type"]').on('change', function (e) {
        toggleAccountMessage(e.target.value);
        $('#account_type').removeClass('is-invalid');
    })

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }


    // if ($('.page-scroll').length) {
    //     // Page scroll
    //     $('.page-scroll').bind('click', function(event) {
    //         var $anchor = $(this);

    //         var headerHeight = $('#header').outerHeight();

    //         $('html, body').stop().animate({
    //             scrollTop: $($anchor.attr('href')).offset().top - headerHeight + 60
    //         }, 750, 'easeInOutExpo');

    //         event.preventDefault();
    //     });
    // }


});

window.focusError = focusError;
let invalid = null;
function focusError(label) {
    if (invalid) {
        return;
    }

    invalid = label;

    setTimeout(() => {
        invalid = null;
    }, 1000)

    let $label = $(`[data-label="${label}"]`);
    if (!$label[0]) {
        return;
    }
    $('html, body').stop().animate({
        scrollTop: $label.offset().top - 100
    }, 750, 'easeInOutExpo');
}

window.registerSubmit = registerSubmit;
function registerSubmit(btn) {
    let form = $('#registerForm')[0];
    if (form.checkValidity()) {
        if (btn) {
            btn.classList.add('disabled');
            btn.innerText = 'Please Wait...';
        }
        form.submit();
    } else {
        form.classList.add('was-validated');
        if (!form.account_type.value) {
            $('#account_type').addClass('is-invalid');
        }
    }
}


//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js